// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import gamingPad01Icon from "@/assets/icons/gaming-pad-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type GamingPad01IconProps = Omit<IconProps, "name">;

export function GamingPad01Icon(props: GamingPad01IconProps): React.ReactNode {
  return <Icon name={gamingPad01Icon} {...props} />;
}
